/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Canpausewrapuptime4Inputs */

const en_entity_canpausewrapuptime4 = /** @type {(inputs: Entity_Canpausewrapuptime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can Pause Wrap-Up Time`)
};

const de_entity_canpausewrapuptime4 = /** @type {(inputs: Entity_Canpausewrapuptime4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Nachbearbeitungszeit pausieren`)
};

/**
* | output |
* | --- |
* | "Can Pause Wrap-Up Time" |
*
* @param {Entity_Canpausewrapuptime4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_canpausewrapuptime4 = /** @type {((inputs?: Entity_Canpausewrapuptime4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Canpausewrapuptime4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_canpausewrapuptime4(inputs)
	return de_entity_canpausewrapuptime4(inputs)
});
export { entity_canpausewrapuptime4 as "entity_canPauseWrapUpTime" }